/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */


interface PermissionSelectOption {
  value: string;
  label: string;
}

const userSelect: PermissionSelectOption[] = [
  { value: 'owner', label: 'Owner' },
  { value: 'manager', label: 'Administrator' },
  { value: 'user', label: 'User' },
  { value: 'contributor', label: 'Contributor' },
  { value: 'verifier', label: 'Verifier' },
  { value: 'viewer', label: 'Viewer' },
  { value: 'guest', label: 'Guest (Deprecated)' },
];

export const dashboardPermissions: PermissionSelectOption[] = [

  // Menu items
  { value: 'summary', label: 'Profile' },
  { value: 'impact', label: 'Sustainability performance' },
  { value: 'universal_trackers', label: 'Universal Trackers' },
  { value: 'frameworks', label: 'Management Framework' },
  { value: 'financial', label: 'Financial Performance' },
  { value: 'documents', label: 'Documents and Media' },
];

export const permissionGroups: {name: string, options: PermissionSelectOption[]}[] = [
  {
    name: 'User permissions',
    options: userSelect,
  },
  // {
  //   name: 'Dashboard Permissions',
  //   options: dashboardPermissions,
  // }
];

export const nodeUsage: PermissionSelectOption[] = [

  // Menu items
  { value: 'menu_dropdowns', label: 'Dropdown' },
  { value: 'initiative_structure', label: 'Navigation Map' },
  { value: 'menu_summary', label: 'Profile' },
  { value: 'menu_impact_performance', label: 'Sustainability performance' },
  { value: 'menu_universal_trackers', label: 'Universal Trackers' },
  { value: 'menu_universal_trackers_disaggregations', label: 'Universal Trackers (disaggregations)' },
  { value: 'menu_pitchbook', label: 'Pitch-Book (mock dashboard)' },
  { value: 'menu_frameworks', label: 'Management Framework' },
  { value: 'menu_financial_performance', label: 'Financial Performance' },
  { value: 'menu_documents_and_media', label: 'Documents and Media' },
];

export interface UserPermissions {
  initiativeId: string;
  permissions: string[];
}
